<template>
  <div class="invitacion-container">

    <!-- 🖼️ FONDO -->
    <div class="fondo-imagen"></div>

    <!-- 🌸 CARD ENCIMA DEL FONDO -->
    <div class="invitacion-card">

      <img src="@/assets/f.png" class="sello-decorativo" />
      <img src="@/assets/f.png" class="sello-decorativo sello-secundario" />

      <h1 ref="titulo" class="titulo-principal"></h1>

      <!-- 🖼️ LOGO EN VEZ DE TEXTO -->
      <div ref="nombres" class="subtitulo-logo-container">
        <img src="@/assets/vic.png" class="logo-imagen" alt="Logo" />
      </div>


      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion">Bienvenidos, selecciona idioma:</p>

        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            Español
          </button>
               <button @click="seleccionar('en')" class="btn-idioma">
            English
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const ramaIzquierda = ref(null);
    const ramaDerecha = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const ampersand = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      gsap.from(ramaIzquierda.value, {
        x: -200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
      });

      gsap.from(ramaDerecha.value, {
        x: 200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
        delay: 0.3,
      });

      // Animación de entrada escalonada
      gsap.timeline({ delay: 0.5 })
        .from(titulo.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power2.out',
        })
        .from(nombres.value, {
          opacity: 0,
          y: 30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        }, '-=0.5')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      ramaIzquierda,
      ramaDerecha,
      titulo,
      nombres,
      ampersand,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap'); 
 
/* ===== CONTENEDOR ===== */ 
.invitacion-container{ 
  position: relative; 
  min-height: 100vh; 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  overflow: hidden; 
} 
 
/* ===== FONDO JPG ===== */ 
.fondo-imagen{ 
  position: fixed; 
  inset: 0; 
  width: 100%; 
  height: 100%; 
  background-image: url('@/assets/descarga (26).jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0; 
 
  /* efecto cinematográfico */ 
  filter: brightness(0.75) saturate(1.1); 
} 
 
/* ===== CARD VERDE ===== */ 
.invitacion-card{ 
  position: relative; 
  z-index: 5; 
  width: 100%; 
  max-width: 380px; 
  padding: 80px 22px 70px; 
  border-radius: 0 80px 0 80px; 
  text-align: center; 
 
  /* verde elegante translúcido */ 
  background: linear-gradient( 
    rgba(154, 167, 153, 0.92), 
    rgba(221, 203, 237, 0.92) 
  ); 
 
  backdrop-filter: blur(2px); 
 
  box-shadow: 
    0 18px 50px rgba(0,0,0,.25), 
    0 6px 14px rgba(0,0,0,.15); 
} 
 
/* ===== SELLO ===== */ 
.sello-decorativo{ 
  position: absolute; 
  top: -80px; 
  left: 50%; 
  transform: translateX(-50%) rotate(-1.5deg); 
  width: min(44vw, 240px); 
  z-index: 6; 
  opacity: 0.9; 
 
  filter: 
    drop-shadow(0 10px 18px rgba(0,0,0,0.25)) 
    saturate(0.85) 
    brightness(1.05); 
 
  pointer-events: none; 
} 
 
.sello-secundario{ 
  opacity: 0.5; 
} 
 
/* ===== TEXTO ===== */ 
.titulo-principal{ 
  font-family: 'Dancing Script', cursive; 
  font-size: 2.5rem; 
  color: #ffffff; 
} 
 
/* ===== LOGO ===== */ 
.subtitulo-logo-container { 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  margin-top: -20px; 
  margin-bottom: 10px; 
} 
 
.logo-imagen { 
  max-width: 100%; 
  width: 250px !important; 
  height: auto; 
  object-fit: contain; 
} 
 
.fecha{ 
  font-family: 'Montserrat', sans-serif; 
  font-size: 1.4rem; 
  color: #ffffff; 
  margin-bottom: 2rem; 
} 
 
/* ===== IDIOMAS ===== */ 
.seccion-idiomas{ 
  margin-top: 0.2rem; 
} 
 
.instruccion{ 
  font-family: 'Montserrat', sans-serif; 
  font-size: 1rem; 
  color: #ffffff; 
  margin-bottom: 1.3rem; 
} 
 
.opciones-idioma{ 
  display: flex; 
  flex-direction: column; 
  gap: 1rem; 
} 
 
.btn-idioma{ 
  padding: 14px; 
  border-radius: 14px; 
  border: 1px solid #ece5e7; 
  background: #ffffff; 
  font-family: 'Montserrat', sans-serif; 
  cursor: pointer; 
  transition: .3s; 
  color:rgb(45, 63, 56); 
} 
 
.btn-idioma:hover{ 
  transform: translateY(-2px); 
  background: #f7eaea; 
} 
 
/* ===== RESPONSIVE ===== */ 
@media(max-width:480px){ 
  .invitacion-card{ 
    padding: 60px 16px; 
  } 
 
  .logo-imagen { 
    width: 180px; 
  } 
} 
</style>